import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';

const PLATFORMS = ['google_ads', 'facebook', 'instagram', 'linkedin', 'email', 'other'];
const STATUSES = ['draft', 'active', 'paused', 'completed'];

export default function EditCampaign() {
  const {id} = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(null);

  useEffect(() => {
    api(`/marketing/campaigns/${id}`).then(r => r.json()).then(c => setForm({
      name: c.name || '', platform: c.platform || 'google_ads', status: c.status || 'draft',
      externalUrl: c.externalUrl || '', budget: c.budget != null ? String(c.budget) : '',
      startDate: c.startDate || '', endDate: c.endDate || '', notes: c.notes || ''
    })).catch(() => {});
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const body = { ...form, budget: form.budget ? parseFloat(form.budget) : null, startDate: form.startDate || null, endDate: form.endDate || null };
    const res = await api(`/marketing/campaigns/${id}`, { method: 'PUT', body: JSON.stringify(body) });
    if (res.ok) navigate(`/marketing/campaigns/${id}`);
  };

  if (!form) return <Layout><p className="text-gray-500">Loading...</p></Layout>;

  return (
    <Layout>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Edit Campaign</h2>
      <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6 max-w-2xl space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
          <input required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Platform *</label>
            <select value={form.platform} onChange={e => setForm({...form, platform: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2">
              {PLATFORMS.map(p => <option key={p} value={p}>{p.replace('_', ' ')}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
            <select value={form.status} onChange={e => setForm({...form, status: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2">
              {STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">External URL</label>
          <input value={form.externalUrl} onChange={e => setForm({...form, externalUrl: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2" />
        </div>
        <div className="grid grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Budget</label>
            <input type="number" step="0.01" value={form.budget} onChange={e => setForm({...form, budget: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
            <input type="date" value={form.startDate} onChange={e => setForm({...form, startDate: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
            <input type="date" value={form.endDate} onChange={e => setForm({...form, endDate: e.target.value})} className="w-full border border-gray-300 rounded-lg px-3 py-2" />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Notes</label>
          <textarea value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} rows={3} className="w-full border border-gray-300 rounded-lg px-3 py-2" />
        </div>
        <div className="flex gap-3">
          <button type="submit" className="bg-fuchsia-600 text-white px-6 py-2 rounded-lg hover:bg-fuchsia-700">Save</button>
          <button type="button" onClick={() => navigate(`/marketing/campaigns/${id}`)} className="border border-gray-300 px-6 py-2 rounded-lg hover:bg-gray-50">Cancel</button>
        </div>
      </form>
    </Layout>
  );
}
